import SidebarBookingsPriceRoute from 'uplisting-frontend/pods/-sidebar/bookings/price/route';

export default class ProtectionOverviewBookingsPriceRoute extends SidebarBookingsPriceRoute {
  parentRoute = 'protection.overview.bookings';
}
